import { render, staticRenderFns } from "./yTable.vue?vue&type=template&id=3dc8338c&scoped=true"
import script from "./yTable.vue?vue&type=script&lang=js"
export * from "./yTable.vue?vue&type=script&lang=js"
import style0 from "./yTable.vue?vue&type=style&index=0&id=3dc8338c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc8338c",
  null
  
)

export default component.exports